var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      { staticClass: "banner-row" },
      _vm._l(_vm.promotion, function(item) {
        return _c("div", {
          directives: [
            {
              name: "lazy",
              rawName: "v-lazy:background-image",
              value: item.img,
              expression: "item.img",
              arg: "background-image"
            }
          ],
          key: item.id,
          staticClass: "bg-lazy top-banner",
          on: {
            click: function($event) {
              _vm.linkTo(item, "promo")
            }
          }
        })
      })
    ),
    _vm._v(" "),
    _c("div", { staticClass: "banner-list-container" }, [
      _c(
        "ul",
        { staticClass: "banner-list" },
        _vm._l(_vm.banner, function(item, index) {
          return _c("li", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy:background-image",
                value: item.img,
                expression: "item.img",
                arg: "background-image"
              }
            ],
            key: index,
            staticClass: "bg-lazy list-item",
            on: {
              click: function($event) {
                _vm.linkTo(item)
              }
            }
          })
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64896b49", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64896b49","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/Banner.vue
// module id = null
// module chunks = 